<template>
	<div class="hidden lg:flex w-full flex-row rounded-2xl overflow-hidden">
		<div
			class="w-8/12 lg:w-1/2 h-44 lg:h-72 p-4 flex flex-col justify-between border-2 border-primary rounded-2xl rounded-r-none"
		>
			<p class="text-vc-body md:text-vc-header-sm font-bold leading-tight">
				{{ props.data.title }}
			</p>
			<p class="text-vc-small leading-tight">
				{{ props.data.text }}
			</p>
		</div>
		<div
			class="w-4/12 lg:w-1/2 h-44 lg:h-72 rounded-r-2xl overflow-hidden"
			style="aspect-ratio: 1 / 1 !important"
		>
			<img
				:src="props.data.image"
				alt="Image description"
				class="w-full h-full object-cover"
				loading="lazy"
			/>
		</div>
	</div>

	<div class="lg:hidden w-full rounded-2xl overflow-hidden flex flex-col justify-stretch">
		<div
			class="w-full h-52 md:h-64 lg:h-72 rounded-t-2xl overflow-hidden"
			style="aspect-ratio: 1 / 1 !important"
		>
			<img
				:src="props.data.image"
				alt="Image description"
				class="w-full h-full object-cover"
				loading="lazy"
			/>
		</div>

		<div
			class="p-4 pt-3 flex flex-col justify-between grow border-2 border-primary rounded-2xl rounded-t-none"
		>
			<p class="text-vc-body font-bold leading-tight">
				{{ props.data.title }}
			</p>
			<p class="pt-4 text-vc-small leading-tight">
				{{ props.data.text }}
			</p>
		</div>
	</div>
</template>

<script>
export default {
	name: 'TextPhotoComponent',
	props: {
		data: {
			type: Object,
			required: true
		}
	},
	setup(props) {
		return {
			props
		}
	}
}
</script>
